module.exports = __webpack_public_path__ + "static/img/stay-option-icon-barbeque.031bcb1a.svg";